module.exports = __webpack_public_path__ + "img/blog-three.657de425.svg";